"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var PropertyOptionRecord = (0, _immutable.Record)({
  description: null,
  displayOrder: -1,
  doubleData: null,
  hidden: false,
  hubspotDefined: false,
  icon: null,
  label: '',
  readOnly: false,
  value: '',
  originalValue: ''
}, 'PropertyOptionRecord');

PropertyOptionRecord.fromJS = function (json) {
  if (json === undefined || json === null) {
    return json;
  }

  json.originalValue = json.value;
  return PropertyOptionRecord(json);
};

var _default = PropertyOptionRecord;
exports.default = _default;
module.exports = exports.default;